// extracted by mini-css-extract-plugin
export default {"closedOrders":"hq7wS","table":"PyJeU","cancelled":"_LTvF"};